import { render, staticRenderFns } from "./FormatRadioButtons.vue?vue&type=template&id=5c07a373"
import script from "./FormatRadioButtons.vue?vue&type=script&lang=js"
export * from "./FormatRadioButtons.vue?vue&type=script&lang=js"
import style0 from "./FormatRadioButtons.vue?vue&type=style&index=0&id=5c07a373&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports